import React, { useState } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Modal, Button } from "antd";
 
const MapComponent = ({ onClose, onSelect, geoJson = {}, geoData = [], currentCon = "" ,standardUnit}) => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(true);
 
  // console.log("map comp geojson", standardUnit, geoData);
  // console.log("map comp geoData",);
  const colors = ["#FF5733", "#33FF57", "#3357FF", "#FF33A1", "#A133FF", "#33FFF5", "#F5FF33", "#FF8C33", "#8C33FF", "#33FF8C"];

 
  // Function to handle country selection
  const handleSelect = () => {
    if (selectedCountry) {
const selected = geoData.find((data) => data.name === selectedCountry);
      if (selected) {
        onSelect(selected.value); // Pass selected country's value to onSelect
      }
    }
    handleClose();
  };
 
  // Function to close the modal
  const handleClose = () => {
    setIsModalVisible(false);
    onClose();
  };
 
  // Function to set popups on GeoJSON features
  const onEachFeature = (feature, layer) => {
if (feature.properties && feature.properties.NAME) {
const regionData = geoData.find((item) => item.name === feature.properties.NAME);
 
      const popupContent = regionData
? `${feature.properties.NAME}</strong><br/>Value: ${regionData.value}  ${standardUnit ?   `<span>kgCO<sub>2e</sub>/kWh</span>` :   `<span>lbCO<sub>2e</sub>/kWh</span>`}`
: `${feature.properties.NAME}</strong><br/>Value: Not available`;
 
      layer.bindPopup(popupContent);
 
      // Ensure popup opens on click and update selected country
      layer.on("click", function () {
setSelectedCountry(feature.properties.NAME); // Store selected country name
        this.openPopup();
      });
    }
  };
  const style = (feature) => {
    const index = geoData.findIndex((item) => item.name === feature.properties.NAME);
    const color = index !== -1 ? colors[index % colors.length] : "#ff00006b";
    return {
      color: color,
      weight: 1,
      fillOpacity: 0.4,
    };
  };
 
  if (!geoJson || !geoJson.features) {
    console.error("Invalid GeoJSON data");
    return <div>Error: Invalid GeoJSON data</div>;
  }
 
  return (
    <Modal
      title={`Geographical coverage for ${currentCon}`}
      open={isModalVisible}
      onCancel={handleClose}
      footer={[
        <Button key="close" onClick={handleClose}>
          Close
        </Button>,
        <Button key="select" type="primary" onClick={handleSelect} disabled={!selectedCountry}>
          Select
        </Button>,
      ]}
    >
      <MapContainer
        center={currentCon === "USA" ? [39.5, -98.35] : [54.526, 15.2551]}
        zoom={4}
        style={{ width: "100%", height: "60vh" }}
      >
        <TileLayer
url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <GeoJSON
          data={geoJson}
          onEachFeature={onEachFeature}
          // style={{ color: "#ff00006b", weight: 1, fillOpacity: 0.4 }}
          style={style}
        />
      </MapContainer>
    </Modal>
  );
};
 
export default MapComponent;